import { useState, useRef } from 'react';
import useCerrarConEscapeYClickAfuera from '../../hooks/useCerrarConEscapeYClickAfuera';

// Botón de tres puntos con acciones secundarias, para cabeceras de pantalla que en escritorio
// tienen varios botones en fila y en mobile no entran sin desbordar horizontalmente (ver
// pages/RTI/ListadoClientes.js). Deja una sola acción primaria visible junto al título y el
// resto queda acá adentro. `acciones`: [{ label, icon?, onClick }].
export default function MenuAcciones({ acciones }) {
    const [abierto, setAbierto] = useState(false);
    const contenedorRef = useRef(null);

    useCerrarConEscapeYClickAfuera(contenedorRef, abierto, () => setAbierto(false));

    return (
        <div className="mob-menu-acciones" ref={contenedorRef}>
            <button
                type="button"
                className="mob-menu-acciones-boton mob-tocable"
                onClick={() => setAbierto((prev) => !prev)}
                aria-haspopup="menu"
                aria-expanded={abierto}
                aria-label="Más acciones"
            >
                <i className="bi bi-three-dots-vertical" aria-hidden="true" />
            </button>
            {abierto && (
                <div className="mob-menu-acciones-lista" role="menu">
                    {acciones.map((accion) => (
                        <button
                            key={accion.label}
                            type="button"
                            role="menuitem"
                            className="mob-menu-acciones-item mob-tocable"
                            onClick={() => { setAbierto(false); accion.onClick(); }}
                        >
                            {accion.icon && <i className={accion.icon} aria-hidden="true" />}
                            {accion.label}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
}
